import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const bakedPotatoTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#060e9f',
    },
    secondary: {
      main: '#ff6b04',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#ff6b04',
    },
  },
};
